module.exports = __webpack_public_path__ + "img/anli04.8c27565e.png";